// extracted by mini-css-extract-plugin
module.exports = {"gridRightContent":"GridRightContent_gridRightContent__nfjlD"};